import { WretcherResponse } from 'wretch';

export function getFilenameFromContentDisposition(contentDisposition: string) {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(contentDisposition);
  if (matches?.[1]) {
    return matches[1].replace(/['"]/g, '');
  }
  return null;
}

export async function downloadFile(
  response: WretcherResponse,
  fileName?: string
) {
  const url = URL.createObjectURL(await response.blob());
  const fileNameToDownload =
    fileName ??
    getFilenameFromContentDisposition(
      response.headers.get('Content-Disposition') ?? ''
    ) ??
    '';
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.download = fileNameToDownload;
  a.href = url;
  a.click();
  document.body.removeChild(a);
}

export function downloadLocalFile(path: string, fileName?: string) {
  const link = document.createElement('a');
  link.href = path;
  link.download = fileName ?? path.split('/').slice(-1)[0];
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
